import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { getFont, getLineHeight } from '@finect/tabular-utils/getFont';
import { AppLink } from '@finect/tabular-core/AppLink';
import { ButtonLined } from '@finect/tabular-core/ButtonLined';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var CardInfo = styled.div.withConfig({
  displayName: "partials__CardInfo",
  componentId: "sc-jjs0pk-0"
})(["display:flex;position:relative;flex-flow:column;justify-content:space-between;overflow:hidden;width:100%;max-height:185px;padding:24px 16px 20px;border:1px solid ", ";border-radius:", ";box-shadow:0 4px 16px ", ";margin-bottom:", ";background-color:", ";color:", ";&:hover{box-shadow:", ";}&:not(:last-child){margin-bottom:12px;}", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciaryL;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.terciaryL;
}, function (_ref4) {
  var bottomMargin = _ref4.bottomMargin;
  return bottomMargin ? '24px' : '0';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.accent1LL;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.font;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.shadows.extraBlack;
}, minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex-flow: ", ";\n    width: 100%;\n  "])), function (_ref8) {
  var single = _ref8.single;
  return single ? 'row' : 'column';
}));
export var ActionsColumn = styled.div.withConfig({
  displayName: "partials__ActionsColumn",
  componentId: "sc-jjs0pk-1"
})(["display:flex;flex-flow:row;margin-top:8px;margin-left:auto;> div{display:flex;flex-flow:column;justify-content:center;}", ";"], minMediaQueries.tablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-top: 0;\n  "]))));
export var CardColumns = styled.div.withConfig({
  displayName: "partials__CardColumns",
  componentId: "sc-jjs0pk-2"
})(["", ";"], minMediaQueries.phablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: row;\n    align-items: center;\n  "]))));
export var CardMainContent = styled.div.withConfig({
  displayName: "partials__CardMainContent",
  componentId: "sc-jjs0pk-3"
})(["display:flex;flex-flow:row;margin-top:4px;"]);
export var CardTitle = styled.span.withConfig({
  displayName: "partials__CardTitle",
  componentId: "sc-jjs0pk-4"
})(["display:flex;flex-flow:column;", ";font-weight:600;&:hover{color:", ";}"], getFont(0, 'compact'), function (_ref9) {
  var theme = _ref9.theme;
  return theme.linkColor;
});
export var OrganizationName = styled.a.withConfig({
  displayName: "partials__OrganizationName",
  componentId: "sc-jjs0pk-5"
})(["margin-bottom:6px;font-size:24px;font-weight:600;color:", ";&:hover{color:", ";}", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.font;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.linkColor;
}, fontSmoothing);
export var HeadlineInfo = styled.div.withConfig({
  displayName: "partials__HeadlineInfo",
  componentId: "sc-jjs0pk-6"
})(["margin-bottom:18px;font-weight:500;color:", ";", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.terciary;
}, getFont(0));
export var ActionLink = styled(AppLink).withConfig({
  displayName: "partials__ActionLink",
  componentId: "sc-jjs0pk-7"
})(["display:flex;align-items:center;", ";cursor:pointer;&:not(:last-child){margin-right:16px;}svg{margin-left:6px;}"], getFont(-1, 'compact'));
export var ButtonArrow = styled(ButtonLined).withConfig({
  displayName: "partials__ButtonArrow",
  componentId: "sc-jjs0pk-8"
})(["display:flex;align-items:center;flex-grow:0;flex-shrink:1;background-color:", ";svg{margin:6px;}"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.terciaryLL;
});
export var AggregatedBadge = styled.div.withConfig({
  displayName: "partials__AggregatedBadge",
  componentId: "sc-jjs0pk-9"
})(["position:absolute;top:4px;right:8px;span{min-height:", ";max-height:", ";padding:4px 6px;}a{min-height:", ";max-height:", ";", ";}"], "".concat(getLineHeight(-2, 'compact'), "rem"), "".concat(getLineHeight(-2, 'compact'), "rem"), "".concat(getLineHeight(-2, 'compact'), "rem"), "".concat(getLineHeight(-2, 'compact'), "rem"), getFont(-2, 'compact'));
export var AggregatedBadgeText = styled.span.withConfig({
  displayName: "partials__AggregatedBadgeText",
  componentId: "sc-jjs0pk-10"
})(["min-height:", ";max-height:", ";padding:4px 6px;", ";border-radius:", ";background-color:", ";"], "".concat(getLineHeight(-2, 'compact'), "rem"), "".concat(getLineHeight(-2, 'compact'), "rem"), getFont(-2, 'compact'), function (_ref14) {
  var theme = _ref14.theme;
  return theme.borderRadius;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.accent3M;
});